/**
 * 项目所有请求
 */

import req from "@/utils/request"


// 第一次登录请求
export function authLogin(params) {
  return req.post("/login/authLogin", params)
}

// 验证码
export function sendOtp(params) {
  return req.post("/login/sendOtp",params)
}

// 第二次登录请求
export function doLogin(params) {
  return req.post("/login/doLogin", params)
}
